import { useCookie } from './use-cookie-value';
import { Impersonation } from '../constants/cookies';

const useIsDropIn = () => {
  const { cookieValue } = useCookie(Impersonation);
  return Boolean(cookieValue);
};

export { useIsDropIn };
